import {z} from 'zod';

import {conversationUser} from '../../modules/user/conversationUser';

export const createDmsUserBody = z.object({
  displayName: z
    .string()
    .min(1, 'Display name is required')
    .max(255, 'Display name cannot exceed 255 characters'),
  externalUserId: z
    .string()
    .min(1, 'External user ID is required')
    .max(255, 'External user ID cannot exceed 255 characters'),
});

export type CreateDmsUserBody = z.infer<typeof createDmsUserBody>;

export const createDmsUserResponse = conversationUser.omit({type: true}).extend({
  type: z.literal('DMS').openapi({
    description: 'Type of user',
    example: 'DMS',
  }),
});

export type CreateDmsUserResponse = z.infer<typeof createDmsUserResponse>;
